export default __webpack_public_path__ + "static/media/Number_1_selected_dark.a20db009.svg";